import { render, staticRenderFns } from "./LabelsBarChart.vue?vue&type=template&id=3437bec4&scoped=true&"
import script from "./LabelsBarChart.vue?vue&type=script&lang=js&"
export * from "./LabelsBarChart.vue?vue&type=script&lang=js&"
import style0 from "./LabelsBarChart.vue?vue&type=style&index=0&id=3437bec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437bec4",
  null
  
)

export default component.exports